module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('transition', {
    attrs: {
      "name": _vm.transitionName[_vm.reverse_type]
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    ref: "popover",
    class: _vm.component_class,
    style: (_vm.component_style)
  }, [_vm._t("default")], 2)]), _vm._v(" "), _vm._t("reference")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-232c54bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Popover/Popover.vue
// module id = 623
// module chunks = 0